import { Children, ReactNode } from 'react'

import styles from './FormTemplate.module.scss'


type Props = {
  children: ReactNode
  title: string
}

export const FormTemplate = ({ children, title }: Props) => {
  const rows = Children.toArray(children)

  return (
    <table className={styles.root}>
      <thead>
        <tr>
          <th>{title}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((child, index) => (
          <tr key={index}>
            <td>{child}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
